import * as React from "react";
import { Card, styled, Link } from "@mui/material";
import WishlistCollectionCard, {
  WishlistCollectionCardProps,
} from "../WishlistCollectionCard/wishlist-collection-card";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { assetService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export interface WishlistAddToCollectionCardProps extends WishlistCollectionCardProps {
  onClick?: () => void;
  isSelected?: boolean;
  isDeletable?: boolean;
  idToDelete?: number;
  callback?: () => void;
}

const WishlistAddToCollectionCard: React.FC<WishlistAddToCollectionCardProps> = (props) => {
  const { t } = useTranslation();
  const { isSelected = false, isDeletable = false, onClick = () => {}, ...wishlistCollectionCardProps } = props;
  const enqueueCustomSnackbar = useCustomSnackbar();

  const removeTitle = () => {
    assetService.DeleteFromCollection(props.id, [props.idToDelete!]).then((data) => {
      if (!data.success) return;
      enqueueCustomSnackbar(t("alert:success.titleRemoved", { title: props.title }), "success");
      if (props.callback) props.callback();
    });
  };

  return (
    <WishlistAddToCollectionCardWrapper variant="outlined" aria-selected={isSelected} onClick={onClick}>
      <WishlistCollectionCard {...wishlistCollectionCardProps} />
      {isSelected && <CheckIcon color="primary" />}
      {isDeletable && (
        <Link
          className="collection-remove-link"
          component="button"
          color="error"
          underline="hover"
          disabled={props.idToDelete === undefined}
          onClick={removeTitle}
        >
          <DeleteOutlineOutlinedIcon sx={{ mr: 0.5 }} fontSize="small" />
          {t("button:removeFromCollection")}
        </Link>
      )}
    </WishlistAddToCollectionCardWrapper>
  );
};

export default WishlistAddToCollectionCard;

const WishlistAddToCollectionCardWrapper = styled(Card)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  cursor: "pointer",
  padding: `10px ${theme.spacing(3)} 10px 10px`,
  borderRadius: 6,
  transition: "all .3s ease-out",
  ".collection-remove-link": {
    opacity: 0,
    transition: "opacity .3s",
  },
  "&:hover": {
    background: theme.palette.backgroundAlpha.hover,
    borderColor: theme.palette.backgroundAlpha.borderFocus,
    ".collection-remove-link": {
      opacity: 1,
    },
  },
}));
